__webpack_require__.p = "/global-navigation-loader-poc/referrals-hub/";